const n = "banner", r = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info"
};
export {
  n as BANNER_BASE_CLASS,
  r as BANNER_TYPES
};
